import { render, staticRenderFns } from "./UnitPriceList.vue?vue&type=template&id=0b643324&"
import script from "./UnitPriceList.vue?vue&type=script&lang=js&"
export * from "./UnitPriceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports